__webpack_require__.p = "/wedding-card/";